/** ISO-8601 week of a date (UTC), with the Monday 00:00 UTC that starts it. */
export function isoWeek(d: Date): { year: number; week: number; monday: Date } {
  const day = (d.getUTCDay() + 6) % 7; // Monday = 0
  const monday = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() - day));
  const thursday = new Date(monday.getTime() + 3 * 86_400_000);
  const year = thursday.getUTCFullYear();
  const jan1 = Date.UTC(year, 0, 1);
  const week = 1 + Math.floor((thursday.getTime() - jan1) / (7 * 86_400_000));
  return { year, week, monday };
}

/** The default weekly round for a kickoff: "Week N", Monday to Monday (UTC). */
export function defaultRoundFor(kickoffAt: Date): { name: string; startsAt: Date; endsAt: Date } {
  const { week, monday } = isoWeek(kickoffAt);
  return { name: `Week ${week}`, startsAt: monday, endsAt: new Date(monday.getTime() + 7 * 86_400_000) };
}

export function parseDate(v: unknown): Date | null {
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  if (typeof v !== 'string' || v.length > 40) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}
